import React, { Component } from 'react'
import { connect } from 'react-redux';
import { getTypesSig, removeTipoSignatario } from '../../actions';
import moment from 'moment';
import ModalConfirm from '../Modais/ModalConfirm';
import { Trash2 } from 'react-feather';

class TipoSignatario extends Component {
    state = { descricao: '', iconShow: false }

    componentDidMount(){
        this.props.getTypesSig()
    }   

    remove = () => {
        const { descricao } = this.state
        this.props.removeTipoSignatario({descricao}, res => {
            document.querySelector('#modalConfirm .close').click()
            if(res) this.props.getTypesSig()
        })
    }

    render(){
        //console.log(this.state)
        const { load_signatario, tiposSignatarios } = this.props.signatario
        return(
            <div style={{ display:'flex', flexDirection:'column', alignItems:'center'}}>
                <table className="table table-bordered" id="tableAgrupador">
                    <thead className="thead-dark">
                        <tr>
                            <th scope="col">Descrição</th>
                            <th scope="col">Ação</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            !load_signatario && tiposSignatarios && tiposSignatarios.map( descricao => (
                                <tr key={`tipoSig-${descricao}`}>
                                    <td>{descricao}</td>
                                    <td onClick={() => this.setState({ descricao })}>
                                        <Trash2 style={styles.feather} data-toggle="modal" data-target="#modalConfirm" />
                                    </td>
                                </tr>
                            ))
                        }
                    </tbody>
                </table>
                {load_signatario && <div className="spinner-border" role="status" style={{margin:'5%'}}>
                                <span className="sr-only">Loading...</span>
                            </div>}

                <ModalConfirm load={load_signatario} title={'Atenção!'} accept={this.remove} text={'Deseja realmente excluir este tipo de signatario?'} />
            </div>
        )
    }
}

const styles = {
    feather: {
        width: '16px',
        height: '16px',
        verticalAlign: 'text-bottom',
        marginRight:6,
        cursor: 'pointer'
    }
}

const mapStateToProps = ({ auth, signatario, documentos }) => {
    return {
        auth, signatario, documentos
    }
}

export default connect(mapStateToProps, {
    getTypesSig, removeTipoSignatario
})(TipoSignatario);